import { ArrowUpRight } from "lucide-react";

const works = [
  {
    brand: "Tanishq",
    description:
      "Built the progressive womanhood charter for Tanishq through a series of award-winning campaigns.",
    primary: "https://www.youtube.com/watch?v=wnZduCnSMpk",
    thumb: "https://img.youtube.com/vi/wnZduCnSMpk/maxresdefault.jpg",
    additional: [
      { label: "Watch The Interview", href: "https://www.youtube.com/watch?v=nX_cHu8ljl4&t=1s" },
      { label: "Watch Superwoman", href: "https://www.youtube.com/watch?v=7a58TPoilEU" },
    ],
  },
  {
    brand: "Urban Company",
    description:
      "Built the Dignity of Labour series, with stories that took on gender, caste and ethnicity head-on.",
    primary: "https://www.youtube.com/watch?v=kU3y54ybZqA",
    thumb: "https://img.youtube.com/vi/kU3y54ybZqA/maxresdefault.jpg",
    additional: [
      { label: "Watch Chotte Sapne", href: "https://www.youtube.com/watch?v=RvTNBBJ_aRw" },
      { label: "Watch Chotti Baat", href: "https://www.youtube.com/watch?v=bffSW7obMiY" },
    ],
  },
  {
    brand: "Meta",
    description:
      "Redefined B2B storytelling, because B2B advertising does not need to be boring.",
    primary: "https://youtu.be/z4fEKyGwHDw",
    thumb:
      "https://customer-assets.emergentagent.com/job_executive-rise/artifacts/nrat940e_Meta%20thumbnail.png",
    additional: [],
    objectFitClass: "object-contain",
    thumbBg: "#0E2746",
  },
  {
    brand: "The Hindu",
    description:
      "The inner monologue of a journalist, for the first time, on the newspaper's front page.",
    primary:
      "https://customer-assets.emergentagent.com/job_executive-rise/artifacts/kez5541t_Screenshot%202026-04-27%20at%208.52.50%E2%80%AFPM.png",
    thumb:
      "https://customer-assets.emergentagent.com/job_executive-rise/artifacts/kez5541t_Screenshot%202026-04-27%20at%208.52.50%E2%80%AFPM.png",
    additional: [],
    objectFitClass: "object-contain",
    thumbBg: "#F5F2EC",
  },
  {
    brand: "Britannia",
    description:
      "Preserved the legacies of India's freedom fighters by bringing the Britannia universe together. Built during the text-to-image AI era.",
    primary: "https://www.youtube.com/watch?v=h-lkg2yJIHU",
    thumb: "https://img.youtube.com/vi/h-lkg2yJIHU/maxresdefault.jpg",
    additional: [],
  },
  {
    brand: "Skyscanner",
    description:
      "\u201CI know a guy who knows a guy who knows a guy\u201D has long been the unofficial system for international travel in India. We found a way to insert Skyscanner into that chain, and make it speak fluently to India.",
    primary: "https://www.youtube.com/watch?v=-B1rbuU-YSo",
    thumb: "https://img.youtube.com/vi/-B1rbuU-YSo/maxresdefault.jpg",
    additional: [],
  },
];

export default function Work() {
  return (
    <section
      id="work"
      data-testid="work-section"
      className="relative py-28 md:py-36 bg-white border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="reveal max-w-3xl mb-16 md:mb-24">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-5 font-medium">
            01. Showreel
          </div>
          <h2 className="font-display text-[#0A0A0A] text-[34px] sm:text-[44px] lg:text-[56px] font-medium leading-[1.08] tracking-[-0.025em]">
            Showreel
          </h2>
          <p className="mt-6 text-[16px] md:text-[18px] text-[#3A3A3A] leading-[1.65] max-w-2xl">
            A small selection of work built with my team for some of the
            world's most influential brands.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-8 gap-y-12 md:gap-y-16">
          {works.map((w, i) => (
            <WorkCard key={w.brand} work={w} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function WorkCard({ work, index }) {
  const Wrapper = work.primary ? "a" : "div";
  const wrapperProps = work.primary
    ? {
        href: work.primary,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-testid": `work-card-link-${index}`,
      }
    : { "data-testid": `work-card-${index}` };

  return (
    <article
      data-testid={`work-card-${index}-wrap`}
      className={`reveal group ${work.spanWide ? "md:col-span-2" : ""}`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <Wrapper
        {...wrapperProps}
        className={`block overflow-hidden bg-[#FAFAF8] border border-black/5 rounded-sm relative ${
          work.spanWide ? "aspect-[16/9]" : "aspect-[4/3]"
        }`}
        style={work.thumbBg ? { backgroundColor: work.thumbBg } : undefined}
      >
        {work.thumb ? (
          <img
            src={work.thumb}
            alt={`${work.brand} campaign thumbnail`}
            loading="lazy"
            className={`w-full h-full ${work.objectFitClass || "object-cover"} transition-transform duration-700 group-hover:scale-[1.03]`}
          />
        ) : (
          <div
            className="w-full h-full flex flex-col items-start justify-between p-7 transition-transform duration-700 group-hover:scale-[1.02]"
            style={{
              background: work.visualBg,
              color: work.visualFg,
            }}
          >
            {work.visualEyebrow && (
              <span className="text-[11px] uppercase tracking-[0.24em] opacity-80 font-medium">
                {work.visualEyebrow}
              </span>
            )}
            <span className="font-display text-[26px] sm:text-[30px] font-medium tracking-[-0.025em] leading-[1.1] whitespace-pre-line">
              {work.visualText}
            </span>
          </div>
        )}
        {work.primary && (
          <span className="absolute top-4 right-4 h-9 w-9 rounded-full bg-white/90 backdrop-blur grid place-items-center text-[#0A0A0A] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <ArrowUpRight size={16} />
          </span>
        )}
      </Wrapper>

      <div className="mt-5">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-[20px] md:text-[22px] text-[#0A0A0A] font-medium tracking-[-0.02em]">
            {work.brand}
          </h3>
          {work.primary && (
            <a
              href={work.primary}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`work-watch-${index}`}
              className="inline-flex items-center gap-1 text-[12px] uppercase tracking-[0.2em] text-[#6B6B6B] hover:text-[#0A0A0A] transition-colors font-medium"
            >
              Watch
              <ArrowUpRight size={12} />
            </a>
          )}
        </div>
        <p className="mt-3 text-[15px] text-[#3A3A3A] leading-[1.6] max-w-md">
          {work.description}
        </p>
        {work.additional && work.additional.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
            {work.additional.map((a) => (
              <a
                key={a.href}
                href={a.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`work-additional-${index}-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="inline-flex items-center gap-1 text-[12px] uppercase tracking-[0.18em] text-[#6B6B6B] hover:text-[#0A0A0A] transition-colors font-medium"
              >
                {a.label}
                <ArrowUpRight size={11} />
              </a>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
